module.exports =  {
    ALL_DAMAGE : 1,
    SUPPORT_DAMAGE : 2,
    TAP_DAMAGE :3,
    TAP_DAMAGE_TOTAL_DPS: 4,
    ALL_SUPPORTER_DAMAGE : 5,
    MANA_BONUS: 6
};
